
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';

@Component({
  selector:'prime-autocomplete',
  template : `<p-autoComplete  [suggestions]="groups" [(ngModel)]="group" (completeMethod)="search($event)" appendTo="body" />`,
  styles:[
    `:host ::ng-deep .p-icon-wrapper {
      pointer-events: unset !important;
      }
      :host ::ng-deep .p-autocomplete .p-autocomplete-input {
        height: 25px;
      }
      :host ::ng-deep .p-autocomplete .p-autocomplete-multiple-container{
        width: 333px;
        overflow-y: scroll;
      }
      `
  ]

})
export class AutoCompleteComponent implements ICellRendererAngularComp {
  params!: any;
  groups : any;
  group: any;

  agInit(params: any): void {
    this.params = params;
    this.group = params.group;
  }

  search(event: any) {
    if (event.query.length > 0) {
      this.groups = this.params.tagGroups.filter((g: string) => g.startsWith(event.query));
    }
  }
  
  refresh() {
    return false;
  }

  getValue() {
    return this.group;
  }
}
